/**
 * exploration 领域的 GameState 分片注册（探索状态）。
 * 由 app/gameStateSlices.ts 清单挂载；字段类型经 declare module 增补到 GameStateSlices。
 */

import { registerGameStateSlice } from '@/IsekaiRPG/modules/runtime/gameStateRegistry';
import { ExplorationStateSchema, type ExplorationState } from './types/explorationGraph';

declare module '@/IsekaiRPG/modules/runtime/gameStateRegistry' {
  interface GameStateSlices {
    /** 探索状态（临时可恢复）；新档缺省 */
    exploration?: ExplorationState;
  }
}

registerGameStateSlice('exploration', ExplorationStateSchema.optional());
